<template>
  <div ref="graphMenu" class="modal-graph-settings">
    <GraphSettingsButton
      :obj="this.sprinklerPressure"
      :displayType="'icon'"
    />
    <GraphSettingsButton
      :obj="this.sprinklerFlow"
      :displayType="'icon'"
    />
    <GraphSettingsButton
      :obj="this.pipePressure"
      :displayType="'icon'"
    />
    <GraphSettingsButton
      :obj="this.velocity"
      :displayType="'icon'"
    />
    <div class="raise-y-axis" @click.stop="">
      <input type="checkbox" class="raise-y-checkbox" v-model="this.raiseYAxisOrigin" />RAISE Y AXIS
    </div>
  </div>
</template>

<script>
import NUIButton from '@/components/nelsonUI/NUIButton';
import { useSettingsStore } from '@/store/SettingsStore';
import GraphSettingsButton from '@/modal/graphSettings/GraphSettingsButton';

export default {
  name: 'ModalGraphSettings',
  data () {
    const settingsStore = useSettingsStore();
    return {
      sprinklerPressure: {
        label: 'Sprklr Pressure',
        icon: 'chart',
        value: 'sprinklerPressure',
        orientation: 'top',
        marker: 'var(--nelson-green)',
        unit: settingsStore.getPressureUnit,
        func: this.toggleSprinklerPressure,
      },
      sprinklerFlow: {
        label: 'Sprklr Flow',
        icon: 'chart',
        value: 'sprinklerFlow',
        orientation: 'top',
        marker: 'var(--nelson-green)',
        unit: settingsStore.getFlowUnit,
        func: this.toggleSprinklerFlow,
      },
      pipePressure: {
        label: 'Pipe Pressure',
        icon: 'chart',
        value: 'pipePressure',
        orientation: 'top',
        marker: 'var(--nelson-blue)',
        unit: settingsStore.getPressureUnit,
        func: this.togglePipePressure,
      },
      velocity: {
        label: 'Velocity',
        icon: 'chart',
        value: 'velocity',
        orientation: 'top',
        marker: 'white',
        unit: settingsStore.getVelocityUnit,
        func: this.toggleVelocity,
      },
      checked: false
    };
  },
  components: {
    GraphSettingsButton,
    NUIButton
  },
  mounted () {
    this.updateMenuPosition();
    window.addEventListener('resize', this.updateMenuPosition);
  },
  updated () {
    this.updateMenuPosition();
  },
  computed: {
    raiseYAxisOrigin: {
      get () {
        return useSettingsStore().getRaiseYAxisOrigin;
      },
      set (value) {
        return useSettingsStore().setRaiseYAxisOrigin(value);
      }
    }
  },
  methods: {
    updateMenuPosition () {
      let graphButton = document.getElementById('graph-settings');
      let graphMenu = this.$refs.graphMenu;
      if (graphMenu) {
        graphMenu.style.left = graphButton.getBoundingClientRect().x + 'px';
        graphMenu.style.top = graphButton.getBoundingClientRect().y +
        graphButton.getBoundingClientRect().height + 'px';
      }
    },
    toggleSprinklerPressure () {
      useSettingsStore().toggleSprinklerPressureVisibility();
    },
    toggleSprinklerFlow () {
      useSettingsStore().toggleSprinklerFlowVisibility();
    },
    togglePipePressure () {
      useSettingsStore().togglePipePressureVisibility();
    },
    toggleVelocity () {
      useSettingsStore().toggleVelocityVisibility();
    }
  }
};
</script>

<style scoped>
.modal-graph-settings {
  position:absolute;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.raise-y-axis {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 65%;
  font-weight: 700;
  background-color: #f7f7f7;
  padding-top: 4px;
  padding-bottom: 4px;
  gap: 2px;
  width: 115px;
  border-top: .5px solid #dedede;
}
.raise-y-checkbox {
  padding: 0 0 0 0;
  margin: 0 0 0 17px;
  cursor: pointer;
}
</style>